<script context="module">
   // export let apiUrl="https://api.tdirect.msk.ru/";
    export const apiUrl="https://work.tdirect.msk.ru/";
    export const axAppUrl="https://axapp.tdirect.msk.ru/";
</script>